import Product from "../entities/Product";
import ProductTypeEnum from "../enums/ProductTipeEnum";
import newProductView from "../views/newProductView";
import returnHome from "../helpers/returnHome";
import displayInfoContainer from "../components/infoContainer";
export function newProductViewLogic(store, mainContent) {
    viewRendering(mainContent);
    populateProductTypesSelectInput();
    newProductFormEvents(store);
}
//view rendering
function viewRendering(mainContent) {
    mainContent.innerHTML = newProductView();
}
//Selector for product types loading
function populateProductTypesSelectInput() {
    var typeSelector = document.getElementById("type-selector");
    for (var item in Object.values(ProductTypeEnum)) {
        var newOption = document.createElement("option");
        newOption.value = Object.keys(ProductTypeEnum)[item];
        newOption.innerHTML = Object.values(ProductTypeEnum)[item];
        typeSelector.appendChild(newOption);
    }
}
//Form events
function newProductFormEvents(store) {
    var newProductForm = document.getElementById("form");
    var newProductSubmitButton = document.getElementById("new-product-submit-button");
    newProductSubmitButton.addEventListener("click", function (event) {
        event.preventDefault();
        try {
            var newProduct = new Product();
            verifyNewProduct(newProduct, newProductForm);
            store.newProduct(newProduct);
            displayInfoContainer("El producto ha sido creado correctamente.");
            returnHome();
        }
        catch (error) {
            displayInfoContainer("" + error);
        }
    });
}
//verify product creation according to Product Class rules
function verifyNewProduct(newProduct, newProductForm) {
    newProduct.id = window.crypto
        .getRandomValues(new Uint32Array(1))[0]
        .toString();
    newProduct.name = newProductForm["product-name"].value;
    newProduct.type = newProductForm["product-type"][newProductForm["product-type"].selectedIndex].text;
    newProduct.price = parseFloat(newProductForm["product-price"].value);
    newProduct.description = newProductForm["product-description"].value;
    newProduct.image = newProductForm["product-image"].value;
    newProduct.thumbnail = newProductForm["product-thumbnail"].value;
    newProduct.stock = parseInt(newProductForm["product-stock"].value);
    newProduct.discount = parseFloat(newProductForm["product-discount"].value);
}
